import SimpleSchema from "../simple";

const schema = {
  surveyDate: {
    type: Date,
    label: "Erhebungsdatum",
    defaultValue: function () {
      return new Date();
    },
    input: "DatePicker",
    group: "Allgemeine Erhebungsdaten",
  },
  name: {
    type: String,
    label: "Dokumentenname",
    group: "Allgemeine Erhebungsdaten",
    max: 100,
    defaultValue: (props, state) => {
      return props.count + 1 + ". Arztbrief";
    },
  },
  anamneseId: {
    type: String,
    label: "Anamnese",
    optional: true,
    input: "Select",
    options: [],
    group: "Wund - und Therapieinformationen",
  },
  therapyRangeStart: {
    type: Date,
    label: "Behandlung seit",
    defaultValue: function () {
      return new Date();
    },
    input: "DatePicker",
    group: "Wund - und Therapieinformationen",
  },
  therapyRangeNow: {
    type: Date,
    label: "Behandlung bis",
    defaultValue: function () {
      return new Date();
    },
    input: "DatePicker",
    group: "Wund - und Therapieinformationen",
  },
  woundNote: {
    type: String,
    label: "Wundbeschreibung",
    optional: true,
    input: "TextArea",
    group: "Wund - und Therapieinformationen",
  },
  note: {
    type: String,
    label: "Anmerkung",
    optional: true,
    input: "TextArea",
    group: "Wund - und Therapieinformationen",
  },
  createdAt: {
    type: Date,
    label: "Date of creation",
    autoValue: function () {
      if (typeof Meteor !== "undefined" && this.isInsert) {
        return new Date();
      } else if (typeof Meteor !== "undefined" && this.isUpsert) {
        return new Date();
      } else if (typeof Meteor === "undefined") {
        return new Date();
      }
    },
    listed: false,
  },
  updatedAt: {
    type: Date,
    label: "Date of change",
    autoValue: function () {
      return new Date();
    },
    optional: true,
    listed: false,
  },
  patientId: {
    type: String,
    label: "PatientId",
    visible: "false",
    defaultValue: (props) => {
      return props.patientId;
    },
  },
  therapyId: {
    type: String,
    label: "TherapyId",
    visible: "false",
    defaultValue: (props) => {
      return props.therapyId;
    },
  },
  createdBy: {
    type: String,
    listed: false,
  },
  companyId: {
    type: String,
    listed: false,
  },
  canceled: {
    type: Boolean,
    label: "Canceled",
    optional: true,
    listed: false,
  },
  deleted: {
    type: Boolean,
    label: "deleted",
    optional: true,
    listed: false,
  },
};

const simpleSchema = new SimpleSchema(schema);
if (typeof Mongo !== "undefined") {
  DoctorsLetters = new Mongo.Collection("doctorsLetters");
  DoctorsLetters.schema = simpleSchema;
  DoctorsLetters.attachSchema(simpleSchema);
  DoctorsLetters._ensureIndex({ therapyId: 1 });
  DoctorsLetters._ensureIndex({ patientId: 1 });
  DoctorsLetters._ensureIndex({ companyId: 1 });
}

export { simpleSchema as DoctorsLetterSchema };

export default schema;
